import { PayloadAction, createSlice } from "@reduxjs/toolkit"

import { RootState } from "../store"
import { subscriptionsApi } from "../queries/subscriptions"
import { leadsApi } from "../queries/lead"
import { TabRangeState, EngagementsTab, DateRange } from "../../types"

export const engagementsSliceName = "engagements"

export interface EngagementsState {
  tabs: {
    range: TabRangeState
  }
  counts: {
    engagements: number | null
    leads: number | null
  }
}

const initialState: EngagementsState = {
  tabs: {
    range: Object.values(EngagementsTab).reduce((acc, key) => {
      acc[key] = key === EngagementsTab.activity ? 30 : 7
      return acc
    }, {} as TabRangeState)
  },
  counts: {
    engagements: null,
    leads: null
  }
}

const engagementsSlice = createSlice({
  name: engagementsSliceName,
  initialState,
  reducers: {
    updateRange: (
      state,
      action: PayloadAction<{
        tabKey: EngagementsTab
        newValue: DateRange
      }>
    ) => {
      const { tabKey, newValue } = action.payload
      state.tabs.range[tabKey] = newValue
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      subscriptionsApi.endpoints.fetchSubscriptionLogs.matchFulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.counts.engagements = action.payload?.length ?? 0
      }
    )
    builder.addMatcher(
      leadsApi.endpoints.fetchLeadLogs.matchFulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.counts.leads = action.payload?.length ?? 0
      }
    )
  }
})

const { reducer, actions } = engagementsSlice

export const { updateRange } = actions

export const selectTabRange = (state: RootState, tabKey: EngagementsTab) =>
  state.engagements.tabs.range[tabKey]

export const selectHasEngagements = (state: RootState) =>
  (state.engagements.counts.engagements ?? 0) > 0

export const selectHasLeads = (state: RootState) =>
  (state.engagements.counts.leads ?? 0) > 0

export const engagementsReducer = reducer
